
(function(template){
define('vue!loginVueApp/pages/SplashPage',['Vue', 'vuex', 'helpers'], function (Vue,Vuex) {
  return {
    name: 'SplashPage',
    template: template,
    computed: _.extend(Vuex.mapState(['firstName']), {}),
    data: function () {
      return {
        services: [],

      };
    },
    beforeMount: function () {
      this.services = app.data.serviceTypes;
     
      window.location.hash = '#/profile/splash/'
    },
  };
});
})('<div class="vue-splash-page"> <h3>Welcome {{ firstName }}!</h3> <div class="splash-page"> <div class="services-list"> <h4>{{localization.loginVue.bookServices}}</h4> <div class="services-div"> <div class="service" v-for="service in services" :key="service.id"> <a class="btn splash-btn" :href="\'#/\' + service.href"> <!-- <i :class="\'icon-\'+service.icon"></i> --> {{ service.name }} </a> </div> </div> </div> <span class="border-for-splash"></span> <div class="upcoming-bookings"> <h4>{{localization.loginVue.bookings}}</h4> <a class="btn" href="#/summary">{{localization.loginVue.viewAllBookingsBtn}}</a> </div> <span class="border-for-splash"></span> <div class="review-profile"> <h4>{{localization.loginVue.reviewProfile}}</h4> <a class="btn" href="#/profile/details">{{localization.loginVue.editProfileBtn}}</a> </div> </div> </div>');
